<template>
  <div class="course-video">
    <div class="video-container">
      <div @click="playVideo" class="video-player">
        <img v-if="wordVideoInfo" :src="wordVideoInfo.iconUrl" alt="视频预览" />
        <div class="play-button">
          <img src="../assets/icon-video-play.png" alt="播放" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CourseVideo",
  props: {
    wordVideoInfo: {
      type: Object,
      default: () => null,
    },
    exampleInfo: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {};
  },
  methods: {
    playVideo() {
      if (this.wordVideoInfo) {
        this.$emit("wordPopUp", {
          data: {
            videoInfo: {
              url: this.wordVideoInfo.videoUrl,
              title: "课件视频",
              poster: this.wordVideoInfo.iconUrl,
            },
            boardInfo: {
              title: "范字板书",
              poster: this.exampleInfo.imageUrl,
            },
          },
          tab: "video",
        });
      }
    },
  },
};
</script>

<style scoped>
.course-video {
  height: 100%;
  background: #ffffff;
  border-radius: 0.92rem 0.92rem 0.92rem 0.92rem;
  box-sizing: border-box;
}

.title {
  margin-bottom: 0.36rem;
  font-weight: 600;
  font-size: 1.23rem;
  color: #3d465e;
}

.video-container {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.92rem 0.92rem 0.92rem 0.92rem;
  border: 0.46rem solid #ceeeff;
}

.video-player {
  width: 100%;
  height: 100%;
  position: relative;
  background: #eee;
  border-radius: 0.4rem;
  overflow: hidden;
}

.video-player img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.play-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 4.62rem;
  height: 4.62rem;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.play-button img {
  width: 4.62rem;
  height: 4.62rem;
}
</style>
